import type { RadioEvent, EventCategory, EventStatus, EventModality } from '@/mocks/adminEvents';
import EventCard from './EventCard';

interface TrendingSectionProps {
  title: string;
  icon: string;
  events: RadioEvent[];
  variant?: 'default' | 'primary' | 'accent';
  onViewEvent?: (event: RadioEvent) => void;
  onShare?: (event: RadioEvent) => void;
  onSave?: (event: RadioEvent) => void;
  savedIds?: number[];
}

export default function TrendingSection({
  title, icon, events, variant = 'default',
  onViewEvent, onShare, onSave,
  savedIds = [],
}: TrendingSectionProps) {
  if (events.length === 0) return null;

  const bgMap = {
    default: 'bg-background-100',
    primary: 'bg-primary-100/60',
    accent: 'bg-accent-100/60',
  };

  const iconBgMap = {
    default: 'bg-background-200 text-foreground-600',
    primary: 'bg-primary-500 text-background-50 dark:text-foreground-950',
    accent: 'bg-accent-500 text-background-50 dark:text-foreground-950',
  };

  return (
    <div className={`rounded-3xl ${bgMap[variant]} p-5 md:p-6 space-y-4`}>
      <div className="flex items-center gap-3">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${iconBgMap[variant]}`}>
          <i className={`${icon} text-base`}></i>
        </div>
        <h3 className="text-base font-extrabold text-foreground-950">{title}</h3>
        <span className="text-[11px] font-medium text-foreground-400 bg-background-50/80 rounded-full px-2 py-0.5">{events.length}</span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {events.map((event) => (
          <EventCard
            key={event.id}
            event={event}
            onClick={onViewEvent}
            onShare={onShare}
            onSave={onSave}
            isSaved={savedIds.includes(event.id)}
          />
        ))}
      </div>
    </div>
  );
}